import React, { useEffect, useState, Fragment } from 'react';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import ReactDatatable from "@ashvin27/react-datatable";
import Header from '../../Components/Header';
import Sidebar from '../../Components/Sidebar';
import { MatEditor } from "maticzeditor"
import { useSelector } from 'react-redux';
import { AddProduct, AddProductPlan, ChartDBData, CountForAdminPack, EditplansData, GetProductDatas, Notifcation, PackBuyerCount, PackBuyerssList, ProductChecker, Productvalidate, RevenueAnnual, UpdateProduct, getPackEditdata, planvalidate } from '../../actions/users';
import { toastAlert } from '../../lib/toastAlert';
import config from "../../lib/config";
import $ from "jquery";
import Select from "react-select";
import isEmpty from '../../lib/isEmpty';
import axios from 'axios';
import dummy from "../../assets/images/dummy.png";
import AddPlanModal from '../../Components/Modals/SubscriptionPlans/AddPlanModal';
import UpdatePlanModal from '../../Components/Modals/SubscriptionPlans/UpdatePlanModal';
import DeletePlanModal from '../../Components/Modals/SubscriptionPlans/DeletePlanModal';
import AddProductModal from '../../Components/Modals/Product/AddProductModal';
import UpdateProductModal from '../../Components/Modals/Product/UpdateProductModal';
import DeleteProductModal from '../../Components/Modals/Product/DeleteProductModal';
import ViewPlanModal from '../../Components/Modals/SubscriptionPlans/ViewPlanModal';

const initialFormValue = {
  PackName: "",
  displayName: "",
  ShortDiscription: "",
  Discrption: "",
  ERC: false,
  Soulbound: false,
  Bulkminting: false,
  file: "",
  filename: "",
  Price: "",
  address: "",
  _id: "",
  Currency: "",
  units1: [],
  units1price: [],
  RangeAndPrice: [],
  TokenScanner: false,
  DashBoardAndProfile: false,
  DomainCampaign: false,
  Country: "",
};

const initialProduct = {
  ProductName: "",
  DisplayName: "",
  ProductDiscription: "",
  Country: "",
  ProductCurrency: "",
  file: "",
  filename: "",
  PlanSelected: [],
};

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff",
    position: "relative",
    top: "3px",
    left: "0px",
    width: "100%",
    maxWidth: "100%",
    color: "#000",
  }),
  option: (provided, state) => ({
    ...provided,
    marginBottom: "5px",
    backgroundColor: "transparent",
    maxWidth: "356px",
    color: "#000",
    borderBottom: "#fff",
    "&:hover": {
      transition: "all 0.5s ease",
      color: "#e50914",
    },
    "&:active": {
      transition: "all 0.5s ease",
      color: "#000",
    },
  }),
  control: (provided, state) => ({
    ...provided,
    border: "1px solid transparent",
    boxShadow: "0px 0px",
    "&:hover": {
      border: "1px solid transparent",
      boxShadow: "0px 0px",
    },
    "&:focus": {
      border: "1px solid transparent",
    },
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    border: "1px solid transparent",
  }),
};

const Subscriptionadd = () => {
  const Wallet_Details = useSelector((state) => state.wallet_connect_context);

  const [properties, setProperties] = useState([]);
  const [Datess, SetDatess] = useState([]);
  const [yearr, Setyear] = useState([]);
  const [Monthsss, SetMonthss] = useState([]);
  const [catagory, SetcatChange] = useState("Year");
  const [Xaxis, setXaxis] = useState([]);
  const [Yaxis, setYaxis] = useState([]);
  const [responsive, setresponsive] = useState(true);
  const [PackDetails, SetPackDetails] = useState([]);
  const [BuyerrsCount, SetBuyCount] = useState({});
  const [SubcriberCount, SetSubcriberCount] = useState("");
  const [NewSub, setNewSub] = useState();
  const [Notification, SetNotification] = useState([]);

  const [formValue, setFormValue] = useState(initialFormValue);
  const [ProductForm, setProductForm] = useState(initialProduct);
  const [filess, set_file] = useState("");
  const [preview_file, set_preview_file] = useState("");
  const [Plans, SetPlans] = useState([]);
  const [Product, SetProduct] = useState([]);
  const [filepath, Setfilepath] = useState("");
  const [plandel, Setplandel] = useState("");
  const [Counttt, SetCountt] = useState({});
  const [validateError, setValidateError] = useState({});
  const [PlannedLaunchpad, SetPlannedLaunchpad] = useState([
    { value: "ERC721", label: "Preparing Images & Data" },
    { value: "Bulkminting", label: "Web3 Introductory and Hands-On Webinar" },
    { value: "mark", label: "Go-To-Market" },
    { value: "compa", label: "Compaign Planning and Brainstorming" },
    { value: "design", label: "Design Artwork" },
    { value: "dao", label: "DAO & Community Building" },
    { value: "add", label: "+ Add New" },
  ]);

  const [InputCount, setInputCount] = useState(1);
  const [AddTire, setAddTire] = useState({});
  const [AddRagePrice, setAddRagePrice] = useState([]);
  const [preview_file__Product, set_preview_file_Product] = useState("");
  const [SelectedPlan, SetSelectedPlan] = useState({});
  const [filepathProduct, SetfilepathProduct] = useState("");
  const [filess_Procduct, set_file_Procduct] = useState("");
  const [answer, setanswer] = useState("");
  const [Revenuee, SetRevenue] = useState(0);
  const [PlanShowTable, SetPlanShowTable] = useState([])

  const [addPlanModal, setAddPlanModal] = useState(false)
  const [updatePlanModal, setUpdatePlanModal] = useState(false)
  const [deletePlanModal, setDeletePlanModal] = useState(false)
  const [addProductModal, setAddProductModal] = useState(false)
  const [updateProductModal, setUpdateProductModal] = useState(false)
  const [deleteProductModal, setDeleteProductModal] = useState(false)
  const [viewPlanModal, setViewPlanModal] = useState(false)


  useEffect(() => {
    PackBuyerList();
    BuyCount();
    NotifcationSend();
    SubScriberLsit();
    RevenueAnnualSet();
    AdminPurchseCount();
  }, []);

  const PackBuyerList = async () => {
    var test = await PackBuyerssList();
    if (test.Message == "success") {
      SetSubcriberCount(test.ListingBuyers.length);
    } else {
    }
  };

  const BuyCount = async () => {
    var Count = await PackBuyerCount();
    if (Count.data.Message == "success") {
      SetPackDetails(Count.data.PackDetail);
      SetBuyCount(Count.data.BuyersCount);
    } else {
      toastAlert("error", "error in server");
    }
  };

  const NotifcationSend = async () => {
    var Count = await Notifcation();
    if (Count.data.Message == "success") {
      SetNotification(Count.data.userValue);
    } else {
      toastAlert("error", "error in server");
    }
  };

  const SubScriberLsit = async () => {
    var test = await PackBuyerssList();
    if (test.Message == "success") {
      setNewSub(test.ListingBuyers);
    } else {
    }
  };

  const RevenueAnnualSet = async () => {
    var returnData = await RevenueAnnual();
    SetRevenue(returnData?.data?.revenue[0]?.sum);
  };

  const AdminPurchseCount = async () => {
    var testtt = await CountForAdminPack();
    if (testtt.data.Success == true) {

      var val = []
      let starter_len = testtt?.data?.revenue?.filter((item) => item._id == "Starter")
      if (starter_len.length > 0) val.push(starter_len[0])
      else val.push({ _id: "Starter", lastSalesDate: 0 })

      let prof_len = testtt?.data?.revenue?.filter((item) => item._id == "Professional")
      if (prof_len.length > 0) val.push(prof_len[0])
      else val.push({ _id: "Professional", lastSalesDate: 0 })

      let Agency_len = testtt?.data?.revenue?.filter((item) => item._id == "Agency")
      if (Agency_len.length > 0) val.push(Agency_len[0])
      else val.push({ _id: "Agency", lastSalesDate: 0 })

      SetCountt(val)

    }
  };

  useEffect(() => {
    ChartData();
    getplans();
    GetProduct();
  }, [catagory]);

  const getplans = async () => {
    var plans = await getPackEditdata();

    if (plans.userValue.length) {
      SetPlans(plans.userValue);
    }
  };

  const GetProduct = async () => {
    var plans = await GetProductDatas();
    if (plans.data.Product.length) {
      SetProduct(plans.data.Product);
    }
  };

  const ChartData = async () => {
    var Datass = await ChartDBData();
    var yearArr = [];
    var dateArr = [];
    var MonthArr = [];
    var map = Datass.userValue.map((item, index) => {
      setProperties(item);
      dateArr.push(item.day);
      yearArr.push(item.year);
      MonthArr.push(item.month);
    });
    Setyear(yearArr);
    SetDatess(dateArr);
    SetMonthss(MonthArr);

    if (catagory == "Year") {
      const toFindDuplicates = (yearArr) =>
        yearArr.filter((item, index) => yearArr.indexOf(item) == index);
      const duplicateElementa = toFindDuplicates(yearArr);
      var elementCounts = yearArr.reduce(
        (count, item) => ((count[item] = count[item] + 1 || 1), count),
        {}
      );
      var Keyss = Object.values(elementCounts);
      var valuess = Object.keys(elementCounts);
      setXaxis(Keyss);
      setYaxis(valuess);
    } else if (catagory == "Month") {
      const toFindDuplicates = (MonthArr) =>
        MonthArr.filter((item, index) => MonthArr.indexOf(item) == index);
      const duplicateElementa = toFindDuplicates(MonthArr);
      var elementCounts = MonthArr.reduce(
        (count, item) => ((count[item] = count[item] + 1 || 1), count),
        {}
      );
      var Keyss = Object.values(elementCounts);
      var valuess = Object.keys(elementCounts);
      setXaxis(Keyss);
      setYaxis(valuess);
    } else if (catagory == "Day") {
      const toFindDuplicates = (dateArr) =>
        dateArr.filter((item, index) => dateArr.indexOf(item) == index);
      const duplicateElementa = toFindDuplicates(dateArr);
      var elementCounts = dateArr.reduce(
        (count, item) => ((count[item] = count[item] + 1 || 1), count),
        {}
      );
      var Keyss = Object.values(elementCounts);
      var valuess = Object.keys(elementCounts);
      setXaxis(Keyss);
      setYaxis(valuess);
    }
  };

  const handlechangeCheckBox = (e) => {
    const { id, Checked } = e.target;
    let formData = { ...formValue, [id]: e.target.checked };
    setFormValue(formData);
  };

  const ClickShowPlans = async (data) => {
    if (data?.length > 0) {
      setViewPlanModal(true)
      SetPlanShowTable(data)
    }
  };

  function pageChange(pageData) {
  }

  const ErrClears = () => {
    setValidateError({})
    setFormValue(initialFormValue);
    var formdata = {}
    setAddTire(formdata)
  }

  const onChangeProduct = (e) => {
    const { id, value } = e.target;
    let formData = { ...ProductForm, ...{ [id]: value } };
    setProductForm(formData);
  };

  const OnChangeProduct = async (e) => {
    var formData = [];
    if (e.value) {
      var filterProduct = await Product.filter(
        (Product) => Product.ProductName === e.value
      );

      SetfilepathProduct(filterProduct[0].filepath);
      setProductForm(filterProduct[0]);
    }
  };

  const onplanchange = async (e) => {
    var formData = [];
    if (e.value) {
      var filterPlans = await Plans.filter(
        (plans) => plans.PackName === e.value
      );
      Setfilepath(filterPlans[0].filepath);
      setFormValue(filterPlans[0]);
      setInputCount(Object.keys(filterPlans[0].RangeAndPrice[0]).length / 2);
      setAddTire(filterPlans[0].RangeAndPrice[0]);
    }
  };

  const AddPlan = async () => {
    formValue.units1price = AddTire;
    formValue.Discrption = answer;
    var checcccc = {
      Currency: formValue.Currency
    }
    var unit = Object.keys(AddTire).filter(key => key.includes('unit'))?.length;
    var price = Object.keys(AddTire).filter(key => key.includes('Price'))?.length;
    var price1 = Object.values(AddTire).filter(key => key == "0")
    if (formValue.Currency == "" || unit != price || price1.length > 0) {
      if (formValue.Currency == "" || unit != price) {
        toastAlert("error", "Fill the reqried fields")
      } else if (price1.length > 0) {
        toastAlert("error", "Units price should not be zero")
      }
    } else {

      var productChecker = await ProductChecker(checcccc)
      if (productChecker.Message !== "Fail") {
        var checkerr = await planvalidate(checcccc)
        if (checkerr?.FindDatas?.length < 4) {
          var validate = await validation(formValue)
          if (!isEmpty(validate)) {
            toastAlert("error", "Validation failed");
            setValidateError(validate);
          } else {
            var addplan = await AddProductPlan(formValue);
            if (addplan.Success == true) {
              toastAlert("success", addplan.Message);
              // $("#addPlan").modal("hide");
              window.location.reload();
            } else {
              toastAlert("error", addplan.Message);
            }
          }
        } else {
          toastAlert("error", "you can only add 4 plans")
        }
      } else {
        toastAlert("error", "There is no product for this plan")
      }

    }
  };

  const onChange = (e) => {

    const { id, value } = e.target;
    let formData = { ...formValue, ...{ [id]: value } };
    setFormValue(formData);
  };

  const selectFileChange = (e) => {
    var validExtensions = [
      "png",
      "gif",
      "webp",
      "mp4",
      "PNG",
      "jpg",
      "JPEG",
      "jpeg",
      "JPG",
    ];
    if (e.target && e.target.files) {
      var reader = new FileReader();
      var file = e.target.files[0];
      var fileName = file.name;
      var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
      if ($.inArray(fileNameExt, validExtensions) === -1) {
        toastAlert("error",
          "Only these file types are accepted : " + validExtensions.join(", ")
        );
        return false;
      }
      const fileSize = file.size;
      if (30000000 < fileSize) {
        toastAlert("error", "File size exceeds 30 MB");
        return false;
      } else {
        set_file(file);

        let formData = {
          ...formValue,
          ...{
            file: file,
            filename: fileName,
            address: Wallet_Details?.UserAccountAddr,
          },
        };
        setFormValue(formData);
        var url = reader.readAsDataURL(file);
        reader.onloadend = function (e) {
          if (reader.result) {
            set_preview_file(reader.result);
          }
        }.bind(this);
      }
    }
  };

  const selectFileChangeProduct = (e) => {
    var validExtensions = [
      "png",
      "gif",
      "webp",
      "mp4",
      "PNG",
      "jpg",
      "JPEG",
      "jpeg",
      "JPG",
    ];
    if (e.target && e.target.files) {
      var reader = new FileReader();
      var file = e.target.files[0];
      var fileName = file.name;
      var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
      if ($.inArray(fileNameExt, validExtensions) === -1) {
        toastAlert("error",
          "Only these file types are accepted : " + validExtensions.join(", ")
        );
        return false;
      }
      const fileSize = file.size;
      if (30000000 < fileSize) {
        toastAlert("error", "File size exceeds 30 MB");
        return false;
      } else {
        set_file_Procduct(file);

        let formData = {
          ...ProductForm,
          ...{
            file: file,
            filename: fileName,
            address: Wallet_Details?.UserAccountAddr,
          },
        };
        setProductForm(formData);
        var url = reader.readAsDataURL(file);
        reader.onloadend = function (e) {
          if (reader.result) {
            set_preview_file_Product(reader.result);
          }
        }.bind(this);
      }
    }
  };

  const onplanchangeProduct = async (e) => {
    if (e.value) {
      var filterPlans = await Plans.filter(
        (plans) => plans.PackName === e.value
      );
      SetSelectedPlan(filterPlans[0]);
    }
  };

  const AddProductAcc = async () => {
    ProductForm.PlanSelected = SelectedPlan;
    var checcccc = {
      Currency: ProductForm.ProductCurrency
    }
    var checkerr = await Productvalidate(checcccc)
    if (checkerr?.Message == "fail") {
      var validate = await validationProduct(ProductForm);
      if (!isEmpty(validate)) {
        setValidateError(validate);
      } else {
        var addplan = await AddProduct(ProductForm);
        if (addplan.Success == true) {
          toastAlert("success", addplan.Message);
          window.location.reload();
        } else {
          toastAlert("error", addplan.Message);
        }
      }
    }
    else {
      toastAlert("error", "Product currency Already Exist")
    }
  };

  const UpdateProductAdmin = async () => {
    var validate = await validationProduct(ProductForm);
    if (!isEmpty(validate)) {
      setValidateError(validate);
    } else {
      ProductForm.PlanSelected = SelectedPlan;
      var addplan = await UpdateProduct(ProductForm);

      if (addplan.Success == true) {
        toastAlert("success", addplan.Message);
        window.location.reload()
      } else {
        toastAlert("error", addplan.Message);
      }
    }
  };

  const validationProduct = async (form, update) => {
    var validationerr = {};
    let dateRegex = /[^0-9]/;
    if (update == "Update") {
      if (form.PackName == "") {
        toastAlert("error", "please select plan to update");
      }
    }
    if (form.ProductName === "") {
      validationerr.ProductName = "ProductName cannot be Empty";
    }
    if (form.DisplayName === "") {
      validationerr.DisplayName = "DisplayName cannot be Empty";
    }
    if (form.ProductDiscription === "") {
      validationerr.Price = "ProductDiscription cannot be Empty";
    }
    return validationerr;
  };

  const onplandel = (e) => {
    Setplandel(e);
  };
  const plandelete = async (e) => {
    axios({
      method: "get",
      url: config.API + "/admin/panel/DeletePlan",
      params: plandel,
    }).then((data) => {
      toastAlert("success", "Plan deleted Successfully");
      window.location.reload();
    });
  };

  const pushAndPopdata = (e, index) => {
    const { id, value } = e.target;

    let formData = { ...AddTire, ...{ [id]: e.target.value } };
    setAddTire(formData);
  };

  const pushAndPopAdd = (index) => {
    var Array = [];
    setInputCount(InputCount + 1);
  };

  const DeleteProduct = async (e) => {
    axios({
      method: "get",
      url: config.API + "/admin/panel/DeleteProduct",
      params: plandel,
    }).then((data) => {
      toastAlert("success", "Plan deleted Successfully");
      window.location.reload();
    });
  };
  const onEditorChange = (e) => {
    var description_text = e;
    setanswer(description_text);
  };

  const UpdatePlan = async () => {
    var validate = await validation(formValue, "Update");

    if (!isEmpty(validate)) {
      setValidateError(validate);
    } else {
      formValue.units1price = AddTire;
      formValue.Discrption = answer;
      var addplan = await EditplansData(formValue);

      if (addplan.Success == true) {
        toastAlert("success", addplan.Message);
        window.location.reload();
      } else {
        toastAlert("error", addplan.Message);
      }
    }
  };

  const validation = async (form, update) => {
    var validationerr = {};
    let dateRegex = /[^0-9]/;
    if (update == "Update") {
      if (form.PackName == "") {
        toastAlert("error", "please select plan to update");
      }
    }
    if (form.PackName === "") {
      validationerr.PackName = "PackName cannot be Empty";
    }
    if (form.Discrption === "") {
      validationerr.Discrption = "Discrption cannot be Empty";
    }
    if (form.Currency === "") {
      validationerr.Currency = "Currency cannot be Empty"
    }
    if (form.Country === "") {
      validationerr.Country = "Country cannot be Empty"
    }
    if (form.displayName === "") {
      validationerr.displayName = "displayName cannot be Empty"
    }
    if (form.ShortDiscription === "") {
      validationerr.ShortDiscription = "ShortDiscription cannot be Empty"
    }
    if (form.Price === "" || dateRegex.test(form.Price) == true) {
      validationerr.Price = "Price cannot be Empty And it must be in Number";
    }
    return validationerr;
  };

  const configdata = {
    page_size: 4,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: "No user found!",

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: (
          <>
            Previous{" "}
          </>
        ),
        next: (
          <>
            Next
          </>
        ),
        last: "Last",
      },
    },
    show_length_menu: false,
    show_filter: true,
    show_pagination: true,
    show_info: true,
    defaultSortAsc: true,
  };

  const configdata12 = {
    page_size: 4,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: "No Plans found!",

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: false,
    show_info: false,
    defaultSortAsc: false,
  };

  const columns = [
    {
      key: "PackName",
      text: "Pack Name",
      className: "PackName",
      align: "left",
      sortable: false,
    },

    {
      key: "Currency",
      text: "Currency",
      className: "Currency",
      align: "left",
      sortable: false,
    },

    {
      key: "Price",
      text: "Price",
      className: "Price",
      align: "left",
      sortable: false,
    },
    {
      key: "displayName",
      text: "Display Name",
      className: "displayName",
      width: 100,
      align: "left",
      sortable: false,
    },
    {
      key: "CreateTime",
      text: "Create Time",
      className: "CreateTime",
      width: 100,
      align: "left",
      sortable: false,
    },
  ];

  const columnsProduct = [
    {
      key: "ProductName",
      text: "Product Name",
      className: "ProductName",
      align: "left",
      sortable: false,
    },

    {
      key: "DisplayName",
      text: "Display Name",
      className: "DisplayName",
      align: "left",
      sortable: false,
    },

    {
      key: "ProductCurrency",
      text: "Product Currency",
      className: "ProductCurrency",
      align: "left",
      sortable: false,
    },
    {
      key: "PlanSelected",
      text: "Plans",
      className: "Plans",
      align: "left",
      sortable: false,
      cell: (record) => (
        <div>
          <p className="subs_tbl_plan_txt plans_color" onClick={() => ClickShowPlans(record?.PlanDetails)}>{record?.PlanDetails?.length + " plans"}</p>
        </div>
      ),
    },
    {
      key: "CreateTime",
      text: "Create Time",
      className: "CreateTime",
      width: 100,
      align: "left",
      sortable: false,
    },
  ];

  const columnsPlansTable = [
    {
      key: "PackName",
      text: "Pack Name",
      className: "PackName",
      align: "left",
      sortable: false,
    },

    {
      key: "Currency",
      text: "Currency",
      className: "Currency",
      align: "left",
      sortable: false,
    },

    {
      key: "Price",
      text: "Price",
      className: "Price",
      align: "left",
      sortable: false,
    },
    {
      key: "displayName",
      text: "Display Name",
      className: "displayName",
      width: 100,
      align: "left",
      sortable: false,
    },
    {
      key: "CreateTime",
      text: "Create Time",
      className: "CreateTime",
      width: 100,
      align: "left",
      sortable: false,
    },
  ];

  return (
    <>
      {addPlanModal && (
        <AddPlanModal
          onDismiss={() => setAddPlanModal(false)}
          onChange={onChange}
          validateError={validateError}
          onEditorChange={onEditorChange}
          answer={answer}
          selectFileChange={selectFileChange}
          preview_file={preview_file}
          dummy={dummy}
          handlechangeCheckBox={handlechangeCheckBox}
          AddRagePrice={AddRagePrice}
          AddTire={AddTire}
          InputCount={InputCount}
          pushAndPopdata={pushAndPopdata}
          pushAndPopAdd={pushAndPopAdd}
          AddPlan={AddPlan}
          PlannedLaunchpad={PlannedLaunchpad}
        />
      )}
      {updatePlanModal && (
        <UpdatePlanModal
          onDismiss={() => setUpdatePlanModal(false)}
          onplanchange={onplanchange}
          Plans={Plans}
          customStyles={customStyles}
          formValue={formValue}
          validateError={validateError}
          onChange={onChange}
          answer={answer}
          onEditorChange={onEditorChange}
          selectFileChange={selectFileChange}
          preview_file={preview_file}
          filepath={filepath}
          dummy={dummy}
          AddTire={AddTire}
          InputCount={InputCount}
          pushAndPopdata={pushAndPopdata}
          pushAndPopAdd={pushAndPopAdd}
          handlechangeCheckBox={handlechangeCheckBox}
          UpdatePlan={UpdatePlan}
        />
      )}
      {deletePlanModal && (
        <DeletePlanModal
          onDismiss={() => setDeletePlanModal(false)}
          onplandel={onplandel}
          Plans={Plans}
          customStyles={customStyles}
          plandelete={plandelete}
        />
      )}

      {addProductModal && (
        <AddProductModal
          onDismiss={() => setAddProductModal(false)}
          onChangeProduct={onChangeProduct}
          selectFileChangeProduct={selectFileChangeProduct}
          dummy={dummy}
          onplanchangeProduct={onplanchangeProduct}
          Plans={Plans}
          customStyles={customStyles}
          preview_file__Product={preview_file__Product}
          AddProductAcc={AddProductAcc}
        />
      )}

      {updateProductModal && (
        <UpdateProductModal
          onDismiss={() => setUpdateProductModal(false)}
          OnChangeProduct={OnChangeProduct}
          Product={Product}
          customStyles={customStyles}
          ProductForm={ProductForm}
          onChangeProduct={onChangeProduct}
          selectFileChangeProduct={selectFileChangeProduct}
          preview_file={preview_file}
          filepathProduct={filepathProduct}
          dummy={dummy}
          UpdateProductAdmin={UpdateProductAdmin}
          onplanchangeProduct={onplanchangeProduct}
          Plans={Plans}
        />
      )}

      {deleteProductModal && (
        <DeleteProductModal
          onDismiss={() => setDeleteProductModal(false)}
          onplandel={onplandel}
          Product={Product}
          customStyles={customStyles}
          DeleteProduct={DeleteProduct}
        />
      )}

      {viewPlanModal && (
        <ViewPlanModal
          onDismiss={() => setViewPlanModal(false)}
          responsive={responsive}
          configdata12={configdata12}
          PlanShowTable={PlanShowTable}
          columnsPlansTable={columnsPlansTable}
          pageChange={pageChange}
        />
      )}

      <Container fluid className='common_bg position-relative'>
        <div className='liner'></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12} className='pb-4'>
            <Header title={'Dashboard'} />

            <div className='common_page_scroller mt-4 mt-sm-5 pe-2'>

              <Row className='justify-content-between mb-4'>
                
                <Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={3} className='ms-auto text-end'>
                <Dropdown className='not_btn'>
                    <Dropdown.Toggle className='' variant="success" id="dropdown-basic">
                      <i class="fa-regular fa-bell admin_top_bell_align" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='bell_dropdown_menu_align'>
                    {Notification &&
                            Notification.length &&
                            Notification.map((item, index) => {
                              return (
                                <>
                                  {index < 4 && (
                                    <span class="dropdown-item bell_dropdown_txt_align">
                                      {item?.name == undefined || null
                                        ? item?.Address?.slice(0, 10)
                                        : item?.name}{" "}
                                      has purchased {item?.PackName}
                                    </span>
                                  )}
                                </>
                              );
                            })}
                    </Dropdown.Menu>
                    </Dropdown>
                </Col>
              </Row>

              <Row className=''>
           
                <div>
                  <div xs={12}>
                    <div className="topcardsecs">
                      <div>
                        <div className="card  blackcard_style mb-1">
                          <div className="firstrow">
                            <div>
                              <i class="fa fa-circle admint_nrm_round admin_green_round mb-2" />
                            </div>
                            <div className="div_text">Active Subscribers</div>
                          </div>

                          <div className="graph_align">
                            <div className="count_dtls">
                              <span className="count_txt">{SubcriberCount}</span>
                              <br />

                            </div>
                          </div>
                        </div>
                      </div>




                      {Counttt.length > 0 && Counttt.map((item, index) => {
                        return (
                          <>
                            <div>
                              <>

                                <div className="card five_div_card blackcard_style mb-1">
                                  <div className="firstrow">
                                    <div>
                                      <i class="fa fa-circle admint_nrm_round admin_red_round mb-2"></i>
                                    </div>
                                    <span className="div_text">{item._id}</span>
                                  </div>

                                  <div className="graph_align">
                                    <div className="count_dtls">

                                      <br />
                                      <p className='admint_count_txt'>{item.lastSalesDate}</p>

                                    </div>
                                   
                                  </div>
                                </div>

                              </>

                            </div>
                          </>)
                      })}


                      <div>
                        <div className="card five_div_card blackcard_style mb-1">
                          <div className="firstrow">
                            <div>
                              <i class="fa fa-circle admint_nrm_round admin_sandal_round mb-2"></i>
                            </div>
                            <div className="div_text">Annual Recurring Revenue(ARR)</div>
                          </div>

                          <div className="graph_align">
                            <div className="count_dtls">
                              <span className="count_txt">{" $ " + Revenuee == undefined ? "0" : Revenuee}</span>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Plans Tablesssss */}

                <Row>
                  <Col  xxl={8}
                    xl={8}
                    lg={8}
                    md={12}
                    sm={12}
                    xs={12} className='mt-3'>
                          <div className="mt-3">
                      <div className="d-xl-flex gap-2 scrolablediv">
                        <button
                          className="graybtn btn me-2 mb-2"
                          data-toggle="modal"
                          data-target="#addPlan"
                          onClick={() => setAddPlanModal(true)}
                        >
                          + Add Plan
                        </button>
                        <button
                          className="graybtn btn me-2 mb-2"
                          data-toggle="modal"
                          data-target="#updateplan"
                          onClick={() => setUpdatePlanModal(true)}
                        >
                          + Update Plan
                        </button>
                        <button
                          className="graybtn btn me-2 mb-2"
                          data-toggle="modal"
                          data-target="#deleteplan"
                          onClick={() => setDeletePlanModal(true)}
                        >
                          - Delete Plan
                        </button>
                      </div>

                      <div className="w-100 themetable">
                        <ReactDatatable
                          responsive={responsive}
                          className="table table-striped table-responsive  react_table_border_align themetable"
                          config={configdata}
                          records={Plans}
                          columns={columns}
                          onPageChange={pageChange()}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col  xxl={4}
                    xl={4}
                    lg={4}
                    md={12}
                    sm={12}
                    xs={12} className='mt-3'>
                         <div className="subscriber_whole_dtls_align w-100">
                      <p className="admin_new_subscribers">New Subscribers</p>

                      {NewSub && NewSub.length > 0 ? (
                        <div>
                          {NewSub &&
                            NewSub.map((item, index) => {
                              return (
                                <>
                                  {index < 5 && (
                                    <div className="admin_subscriber_dtls_align w-100">
                                      {item.image == "" || item.image == null ? (
                                        <img
                                          className="admin_dropdown_img_align"
                                          src={require("../../assets/images/faces/marc.jpg")}
                                        />
                                      ) : (
                                        <img
                                          className="admin_dropdown_img_align"
                                          src={`${config.Back_Url}/Users/${item.PrimaryAddr}/profileImg/${item.image}`}
                                        />
                                      )}
                                      <div>
                                        <p className="subscribers_align_dtls">
                                          {item.name == "" || item.name == null
                                            ? item?.Address?.slice(0, 10)
                                            : item.name}
                                          <span className="admin_badge_icon_align">
                                            <i class="fa-solid fa-certificate admin_certificate_icon" />
                                            <i class="fa-solid fa-check admin_tick_icon" />
                                          </span>
                                        </p>

                                        <span className="follwers_count_align">
                                          {item.FollowersCount == undefined
                                            ? ""
                                            : item.FollowersCount + " Followers"}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                        </div>
                      ) : (
                        <h3>No Subscribers Found</h3>
                      )}
                    </div>
                  </Col>
                </Row>


                <Row>
                  <Col  xxl={8}
                    xl={8}
                    lg={8}
                    md={12}
                    sm={12}
                    xs={12} className='mt-3'>
                     <div className="mt-3">
                      <div className="d-xl-flex gap-2 scrolablediv">
                        <button
                          className="graybtn btn me-2 mb-2"
                          data-toggle="modal"
                          data-target="#addproduct"
                          onClick={() => setAddProductModal(true)}
                        >
                          + Add Product
                        </button>
                        <button
                          className="graybtn btn me-2 mb-2"
                          data-toggle="modal"
                          data-target="#UpdateProduct"
                          onClick={() => setUpdateProductModal(true)}
                        >
                          + Update Product
                        </button>
                        <button
                          className="graybtn btn me-2 mb-2"
                          data-toggle="modal"
                          data-target="#deleteProduct"
                          onClick={() => setDeleteProductModal(true)}
                        >
                          - Delete Product
                        </button>
                      </div>

                      <div className="w-100 themetable">
                        <ReactDatatable
                          responsive={responsive}
                          className="table table-striped table-responsive react_table_border_align themetable"
                          config={configdata}
                          records={Product}
                          columns={columnsProduct}
                          onPageChange={pageChange()}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>



             

            

                {/* {/ Edit Modal Content /} */}
                <div
                  class="modal fade"
                  id="y"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog  modal-dialog-scrollable modal-xl">
                    <div class="modal-content">
                      <div class="modal-header edituser_modal_body_align">
                        <h5
                          class="modal-title edit_header_title_align"
                          id="staticBackdropLabel"
                        >
                          Add New User / Edit User
                        </h5>
                        <button
                          type="button"
                          class="close modal_cls_btn_align "
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body edituser_modal_body_align">
                        <div className="">
                          <div container>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <input
                                type="text"
                                id="walletAddress"
                                className="edit_inputs_align"
                                placeholder="Wallet Address*"
                                name="wallet address"
                              />
                            </div>
                            <div container className="mt-1" spacing={1}>
                              <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="First Name*"
                                  name="wallet address"
                                />
                              </div>
                              <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="Last Name*"
                                  name="wallet address"
                                />
                              </div>
                            </div>
                            <div container className="mt-1" spacing={1}>
                              <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="Company Name*"
                                  name="wallet address"
                                />
                              </div>
                              <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="Company Address*"
                                  name="wallet address"
                                />
                              </div>
                            </div>
                            <div container className="mt-1" spacing={1}>
                              <div item xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="Email Address*"
                                  name="wallet address"
                                />
                              </div>
                              <div item xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                <input
                                  type="number"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="Mobile No.*"
                                  name="wallet address"
                                />
                              </div>
                              <div item xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="Company Address*"
                                  name="wallet address"
                                />
                              </div>
                            </div>

                            <div container className="mt-1" spacing={1}>
                              <div item xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="User Name*"
                                  name="wallet address"
                                />
                              </div>
                              <div item xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="Password*"
                                  name="wallet address"
                                />
                              </div>
                              <div item xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align"
                                  placeholder="Confirm Password*"
                                  name="wallet address"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="container-fluid edit_table_container_align">
                            <div class="table-responsive">
                              <table class="table edit_user_table_align">
                                <thead className="tiffany_thead">
                                  <tr>
                                    <th scope="col">Module Permission</th>
                                    <th scope="col">Bulk LazyMint ERC721 & ERC 1155</th>
                                    <th scope="col">Bulk LazyMint SoulBound Tokens</th>
                                    <th scope="col">Token Gating Authenticator</th>
                                    <th scope="col">Campaign Landing Page</th>
                                    <th scope="col">Event & Ticketing Dashboard</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <tr>
                                    <th scope="row">Super Admin</th>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="ERC"
                                        name="ERC"
                                        value="ERC"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="SoulBound"
                                        name="SoulBound"
                                        value="SoulBound"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="TokenGating"
                                        name="TokenGating"
                                        value="TokenGating"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="campaigLanding"
                                        name="campaigLanding"
                                        value="campaigLanding"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="Dashboard"
                                        name="Dashboard"
                                        value="Dashboard"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Free Tier</th>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="ERC"
                                        name="ERC"
                                        value="ERC"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="SoulBound"
                                        name="SoulBound"
                                        value="SoulBound"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="TokenGating"
                                        name="TokenGating"
                                        value="TokenGating"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="campaigLanding"
                                        name="campaigLanding"
                                        value="campaigLanding"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="Dashboard"
                                        name="Dashboard"
                                        value="Dashboard"
                                      />
                                    </td>
                                  </tr>

                                  <tr>
                                    <th scope="row">Starter</th>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="ERC"
                                        name="ERC"
                                        value="ERC"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="SoulBound"
                                        name="SoulBound"
                                        value="SoulBound"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="TokenGating"
                                        name="TokenGating"
                                        value="TokenGating"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="campaigLanding"
                                        name="campaigLanding"
                                        value="campaigLanding"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="Dashboard"
                                        name="Dashboard"
                                        value="Dashboard"
                                      />
                                    </td>
                                  </tr>

                                  <tr>
                                    <th scope="row">Professional</th>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="ERC"
                                        name="ERC"
                                        value="ERC"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="SoulBound"
                                        name="SoulBound"
                                        value="SoulBound"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="TokenGating"
                                        name="TokenGating"
                                        value="TokenGating"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="campaigLanding"
                                        name="campaigLanding"
                                        value="campaigLanding"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="Dashboard"
                                        name="Dashboard"
                                        value="Dashboard"
                                      />
                                    </td>
                                  </tr>

                                  <tr>
                                    <th scope="row">Agency</th>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="ERC"
                                        name="ERC"
                                        value="ERC"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="SoulBound"
                                        name="SoulBound"
                                        value="SoulBound"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="TokenGating"
                                        name="TokenGating"
                                        value="TokenGating"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="campaigLanding"
                                        name="campaigLanding"
                                        value="campaigLanding"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="table_check_align"
                                        id="Dashboard"
                                        name="Dashboard"
                                        value="Dashboard"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* {/ End of Edit Modal Content /} */}

                {/* Add Product Model */}
                <div
                  class="modal fade newthememodal"
                  id="addproduct"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog  modal-dialog-scrollable modal-md">
                    <div class="modal-content">
                      <div class="modal-header edituser_modal_body_align">
                        <h5
                          class="modal-title edit_header_title_align"
                          id="staticBackdropLabel"
                        >
                          Add / Update Product
                        </h5>
                        <button
                          type="button"
                          class="close modal_cls_btn_align"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={() => ErrClears()}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body edituser_modal_body_align">
                        <div className="">
                          <div container>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <span className="labelspan me-2">Name of Product</span>{" "}
                                <input
                                  type="text"
                                  id="ProductName"
                                  className="edit_inputs_align"
                                  placeholder="Enter ProductName*"
                                  onChange={(e) => onChangeProduct(e)}
                                  name="wallet address"
                                />
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Display Name</span>
                                </div>
                                <input
                                  type="text"
                                  id="DisplayName"
                                  className="edit_inputs_align"
                                  placeholder="Enter DisplayName*"
                                  onChange={(e) => onChangeProduct(e)}
                                  name="wallet address"
                                />
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  <span className="labelspan me-2">Description</span>{" "}
                                </div>
                                <textarea
                                  className="edit_inputs_align"
                                  id="ProductDiscription"
                                  onChange={(e) => onChangeProduct(e)}
                                ></textarea>
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Currency</span>
                                </div>
                                <input
                                  type="text"
                                  id="ProductCurrency"
                                  className="edit_inputs_align"
                                  placeholder="Currency*"
                                  name="wallet address"
                                  onChange={(e) => onChangeProduct(e)}
                                />
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  <span className="labelspan me-2">Country</span>
                                </div>
                                <input
                                  type="text"
                                  id="Country"
                                  className="edit_inputs_align"
                                  placeholder="Enter Country*"
                                  name="Country Name"
                                  onChange={(e) => onChangeProduct(e)}
                                />
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Product Image</span>
                                </div>
                                <div className="addplan_mdl_img_inp_dtls">
                                  <span>Select File*</span>

                                </div>
                                <button className="admin_mdl_red_btn admn_img_upld_btn">
                                  Upload
                                  <input
                                    className="addplan_mdl_img_inp addpln_hidden_dtl"
                                    type="file"
                                    name="file"
                                    accept="image/*"
                                    onChange={selectFileChangeProduct}
                                  />
                                </button>
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div className="me-2">
                                  {" "}
                                  <img
                                    src={
                                      preview_file__Product
                                        ? preview_file__Product
                                        : dummy
                                    }
                                    style={{ width: 117 }}
                                  />
                                </div>
                                <p style={{ fontWeight: "500" }}>
                                  Image Dimension <br /> (150 X 150)
                                </p>
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <Select
                                className='update_plan_top_slct'
                                onChange={(e) => onplanchangeProduct(e)}
                                options={Plans}
                                label="Single select"
                                isSearchable={false}
                                styles={customStyles}
                                classNamePrefix="react-select"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </div>
                          </div>
                          <div className="text-right">
                            {" "}
                            <button
                              className="admin_mdl_red_btn mt-4"
                              onClick={() => {
                                AddProductAcc();
                              }}
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* update product */}

                <div
                  class="modal fade newthememodal"
                  id="UpdateProduct"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog  modal-dialog-scrollable modal-md">
                    <div class="modal-content">
                      <div class="modal-header edituser_modal_body_align">
                        <h5
                          class="modal-title edit_header_title_align"
                          id="staticBackdropLabel"
                        >
                          Add / Update Product
                        </h5>
                        <button
                          type="button"
                          class="close modal_cls_btn_align"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body edituser_modal_body_align">
                        <div className="">
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <Select
                              className='update_plan_top_slct'
                              onChange={(e) => OnChangeProduct(e)}
                              options={Product}
                              label="Single select"
                              isSearchable={false}
                              styles={customStyles}
                              classNamePrefix="react-select"
                              formControlProps={{
                                fullWidth: true,
                              }}
                            />
                          </div>
                          <div container>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <span className="labelspan me-2">Name of Product</span>{" "}
                                <input
                                  type="text"
                                  id="ProductName"
                                  className="edit_inputs_align"
                                  placeholder="Enter ProductName*"
                                  value={ProductForm.ProductName}
                                  disabled
                                  name="wallet address"
                                />
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Display Name</span>
                                </div>
                                <input
                                  type="text"
                                  id="DisplayName"
                                  className="edit_inputs_align"
                                  placeholder="Enter DisplayName*"
                                  value={ProductForm.DisplayName}
                                  onChange={(e) => onChangeProduct(e)}
                                  name="wallet address"
                                />
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  <span className="labelspan me-2">Description</span>{" "}
                                </div>
                                <textarea
                                  className="edit_inputs_align"
                                  value={ProductForm.ProductDiscription}
                                  id="ProductDiscription"
                                  onChange={(e) => onChangeProduct(e)}
                                ></textarea>
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Currency</span>
                                </div>
                                <input
                                  type="text"
                                  id="ProductCurrency"
                                  className="edit_inputs_align"
                                  placeholder="Currency*"
                                  name="wallet address"
                                  value={ProductForm.ProductCurrency}
                                  onChange={(e) => onChangeProduct(e)}
                                />
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  <span className="labelspan me-2">Country</span>
                                </div>
                                <input
                                  type="text"
                                  id="Country"
                                  value={ProductForm.Country}
                                  className="edit_inputs_align"
                                  placeholder="Enter Country*"
                                  name="Country Name"
                                  onChange={(e) => onChangeProduct(e)}
                                />
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Product Image</span>
                                </div>
                                <div className="addplan_mdl_img_inp_dtls">
                                  <span>Select File*</span>

                                </div>

                                <button className="admin_mdl_red_btn admn_img_upld_btn">
                                  Upload
                                  <input
                                    className="addplan_mdl_img_inp addpln_hidden_dtl"
                                    type="file"
                                    name="file"
                                    accept="image/*"
                                    onChange={selectFileChangeProduct}
                                  />

                                </button>
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div className="me-2">
                                  {" "}
                                  <img
                                    src={
                                      preview_file
                                        ? preview_file
                                        : filepathProduct
                                          ? config.Back_Url + "/" + filepathProduct
                                          : dummy
                                    }
                                    style={{ width: 117 }}
                                  />
                                </div>
                                <p style={{ fontWeight: "500" }}>
                                  Image Dimension <br /> (150 X 150)
                                </p>
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <Select
                                className='update_plan_top_slct'
                                onChange={(e) => onplanchangeProduct(e)}
                                options={Plans}
                                label="Single select"
                                isSearchable={false}
                                styles={customStyles}
                                classNamePrefix="react-select"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </div>
                          </div>
                          <div className="text-right">
                            <button
                              className="admin_mdl_red_btn mt-4"
                              onClick={() => {
                                UpdateProductAdmin();
                              }}
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* deleted Product */}
                <div
                  class="modal fade newthememodal"
                  id="deleteProduct"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog  modal-dialog-scrollable modal-sm">
                    <div class="modal-content">
                      <div class="modal-body edituser_modal_body_align">
                        <p className="text-danger fw-600">DELETE ITEM</p>
                        <div container className="mt-1" spacing={1}>
                          <div item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Select
                              onChange={(e) => onplandel(e)}
                              options={Product}
                              label="Single select"
                              isSearchable={false}
                              styles={customStyles}
                              classNamePrefix="react-select"
                              formControlProps={{
                                fullWidth: true,
                              }}
                            />
                          </div>
                        </div>
                        <p>Are you sure you would like to delete this plan?</p>
                        <div className="d-flex jc-between flex1 gap-10">
                          <button
                            className="btn btn-danger"
                            onClick={(e) => DeleteProduct(e)}
                          >
                            Delete
                          </button>

                          <button
                            className="btn btn-secondary"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/*Add Plans Model*/}
                <div
                  class="modal fade newthememodal"
                  id="addPlan"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog  modal-dialog-scrollable modal-md">
                    <div class="modal-content">
                      <div class="modal-header edituser_modal_body_align">
                        <h5
                          class="modal-title edit_header_title_align"
                          id="staticBackdropLabel"
                        >
                          Add / Update Plan
                        </h5>
                        <button
                          type="button"
                          class="close modal_cls_btn_align"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={() => ErrClears()}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body edituser_modal_body_align">
                        <div className="">
                          <div container>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex ">
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  Name of Plan
                                </span>
                                <input
                                  type="text"
                                  id="PackName"
                                  className="edit_inputs_align"
                                  placeholder="Plan Name*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {validateError.PackName && (
                                <span className="text-danger mtm-1">
                                  {validateError.PackName}
                                </span>
                              )}
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div>
                                  {" "}
                                  <span className="labelspan mb-sm-0 mb-2 me-2">
                                    Display Name
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  id="displayName"
                                  className="edit_inputs_align"
                                  placeholder="Display Name*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.displayName && <span className="text-danger mtm-1">{validateError.displayName}</span>
                              }
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div>
                                  {" "}
                                  <span className="labelspan mb-sm-0 mb-2 me-2">
                                    Short Discription
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  id="ShortDiscription"
                                  className="edit_inputs_align"
                                  placeholder="Short Discription*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.ShortDiscription && <span className="text-danger mtm-1">{validateError.ShortDiscription}</span>
                              }
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex ">
                                <div>
                                  <span className="labelspan mb-sm-0 mb-2 me-2">
                                    Description
                                  </span>{" "}
                                </div>

                                <MatEditor sendata={answer} outdata={(evt) => onEditorChange(evt)} />
                              </div>
                              {
                                validateError.Discrption && <span className="text-danger mtm-1">{validateError.Discrption}</span>
                              }
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Currency</span>
                                </div>
                                <input
                                  type="text"
                                  id="Currency"
                                  className="edit_inputs_align"
                                  placeholder="Currency*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />
                              </div>
                              {
                                validateError.Currency && <span className="text-danger mtm-1">{validateError.Currency}</span>
                              }

                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  <span className="labelspan me-2">Country</span>
                                </div>
                                <input
                                  type="text"
                                  id="Country"
                                  className="edit_inputs_align"
                                  placeholder="Enter Country*"
                                  name="Country Name"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.Country && <span className="text-danger mtm-1">{validateError.Country}</span>
                              }
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan img_lablespan me-2">
                                    Plan Image
                                  </span>
                                </div>
                                <div className="addplan_mdl_img_inp_dtls">
                                  <span>Select File*</span>

                                </div>
                                <button className="admin_mdl_red_btn admn_img_upld_btn">
                                  Upload
                                  <input
                                    className="addplan_mdl_img_inp addpln_hidden_dtl"
                                    type="file"
                                    name="file"
                                    accept="image/*"
                                    onChange={selectFileChange}
                                  />
                                </button>
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div className="me-2">
                                  {" "}
                                  <img
                                    src={preview_file ? preview_file : dummy}
                                    style={{ width: 117 }}
                                  />
                                </div>
                                <p style={{ fontWeight: "500" }}>
                                  Image Dimension <br /> (150 X 150)
                                </p>
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div>
                                {" "}
                                <span className="labelspan img_lablespan me-2">
                                  Billing Cycle
                                </span>
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className=" ">
                                {[...Array(InputCount)].map((val, index) => {
                                  return (
                                    <div className="d-sm-flex align-items-center mb-2">
                                      <p className="shrink-0 mb-0 f-12 fw-600 me-2 mt-sm-0 mt-2">
                                        Units
                                      </p>
                                      <input
                                        type="text"
                                        id={"units" + index}
                                        className="edit_inputs_align me-2 mb-2 mb-sm-0"
                                        placeholder="Enter units*"
                                        name="wallet address"
                                        onChange={(e) => pushAndPopdata(e, index)}
                                      />
                                      <p className="shrink-0 mb-0 f-12 fw-600 me-2">
                                        Price per Unit
                                      </p>
                                      <input
                                        type="text"
                                        id={"Price" + index}
                                        className="edit_inputs_align me-2 mb-2 mb-sm-0"
                                        placeholder="Enter Price*"
                                        name="wallet address"
                                        onChange={(e) => pushAndPopdata(e, index)}
                                      />
                                      <button
                                        className="admin_mdl_red_btn"
                                        onClick={() => {
                                          pushAndPopAdd(index);
                                        }}
                                      >
                                        Add Tier
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan mb-sm-0 mb-2 me-2">
                                    SetUp fee
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  id="Price"
                                  className="edit_inputs_align me-2"
                                  placeholder="SetUp fee*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {validateError.Price && (
                                <span className="text-danger mtm-1">
                                  {validateError.Price}
                                </span>
                              )}
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex align-items-center">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Launch Pad</span>
                                </div>
                                <input
                                  type="text"
                                  id="walletAddress"
                                  className="edit_inputs_align me-2"
                                  placeholder="Launch Pad*"
                                  name="wallet address"
                                />
                                <p className="shrink-0 mb-0 fw-600 f-12 ">Per unit</p>
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  <span className="labelspan me-2">
                                    Display Launchpad
                                  </span>
                                </div>
                                <div className="w-full">
                                  <Select

                                    className=" themeselect update_plan_top_slct"
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    options={PlannedLaunchpad}
                                  />
                                  
                                </div>
                              </div>
                            </div>
                            <div className="table_div_head">
                              <div class="container-fluid edit_table_container_align">
                                <div
                                  class="table-responsive"
                                  style={{ position: "relative", zIndex: 0 }}
                                >
                                  <table class="table edit_user_table_align">
                                    <thead className="tiffany_thead">
                                      <tr>
                                        <th scope="col">LazyMint ERC721 & ERC 1155</th>
                                        <th scope="col">
                                          Bulk LazyMint SoulBound Tokens
                                        </th>
                                        <th scope="col">Bulk Minting</th>
                                        <th scope="col">Token Scanner</th>
                                        <th scope="col">DashBoard And Profile</th>
                                        <th scope="col">Campaign Page</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="table_check_align"
                                            id="ERC"
                                            name="ERC"
                                            value="ERC"
                                            onChange={(e) => handlechangeCheckBox(e)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="table_check_align"
                                            id="Soulbound"
                                            name="SoulBound"
                                            value="Soulbound"
                                            onChange={(e) => handlechangeCheckBox(e)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="table_check_align"
                                            id="Bulkminting"
                                            name="Bulkminting"
                                            onChange={(e) => handlechangeCheckBox(e)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="table_check_align"
                                            id="TokenScanner"
                                            name="TokenScanner"
                                            onChange={(e) => handlechangeCheckBox(e)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="table_check_align"
                                            id="DashBoardAndProfile"
                                            name="DashBoardAndProfile"
                                            onChange={(e) => handlechangeCheckBox(e)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="table_check_align"
                                            id="DomainCampaign"
                                            name="DomainCampaign"
                                            onChange={(e) => handlechangeCheckBox(e)}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="text-right">
                            {" "}
                            <button
                              className="admin_mdl_red_btn mt-4"
                              onClick={() => {
                                AddPlan();
                              }}
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* update  Edit plan Model*/}
                <div
                  class="modal fade newthememodal"
                  id="updateplan"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog  modal-dialog-scrollable modal-md">
                    <div class="modal-content">
                      <div class="modal-header edituser_modal_body_align">
                        <h5
                          class="modal-title edit_header_title_align"
                          id="staticBackdropLabel"
                        >
                          Add / Update Plan
                        </h5>
                        <button
                          type="button"
                          class="close modal_cls_btn_align"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body edituser_modal_body_align">
                        <div className="">
                          <div container>
                            <div container className="mt-1" spacing={1}>
                              <div item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <Select
                                  onChange={(e) => onplanchange(e)}
                                  options={Plans}
                                  label="Single select"
                                  isSearchable={false}
                                  styles={customStyles}
                                  className="update_plan_top_slct"
                                  classNamePrefix="react-select"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                />
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  Name of Plan
                                </span>{" "}
                                <input
                                  type="text"
                                  id="PackName"
                                  value={formValue.PackName}
                                  className="edit_inputs_align"
                                  placeholder="Wallet Address*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.PackName && <span className="text-danger mtm-1">{validateError.PackName}</span>
                              }
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan mb-sm-0 mb-2 me-2">
                                    Display Name
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  id="displayName"
                                  value={formValue.displayName}
                                  className="edit_inputs_align"
                                  placeholder="displayName*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.displayName && <span className="text-danger mtm-1">{validateError.displayName}</span>
                              }
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div>
                                  {" "}
                                  <span className="labelspan mb-sm-0 mb-2 me-2">
                                    Short Discription
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  id="ShortDiscription"
                                  value={formValue.ShortDiscription}
                                  className="edit_inputs_align"
                                  placeholder="Short Discription*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.ShortDiscription && <span className="text-danger mtm-1">{validateError.ShortDiscription}</span>
                              }
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div>
                                  <span className="labelspan mb-sm-0 mb-2 me-2">
                                    Description
                                  </span>{" "}
                                </div>

                                {formValue.Discrption &&
                                  <MatEditor sendata={answer} outdata={(evt) => onEditorChange(evt)} />
                                }

                              </div>
                              {
                                validateError.Discrption && <span className="text-danger mtm-1">{validateError.Discrption}</span>
                              }
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Currency</span>
                                </div>
                                <input
                                  type="text"
                                  id="Currency"
                                  className="edit_inputs_align"
                                  placeholder="Currency*"
                                  value={formValue.Currency}
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.Currency && <span className="text-danger mtm-1">{validateError.Currency}</span>
                              }
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-flex ">
                                <div>
                                  <span className="labelspan me-2">Country</span>
                                </div>
                                <input
                                  type="text"
                                  id="Country"
                                  className="edit_inputs_align"
                                  placeholder="Enter Country*"
                                  name="Country Name"
                                  value={formValue.Country}
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.Country && <span className="text-danger mtm-1">{validateError.Country}</span>
                              }
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div>
                                  {" "}
                                  <span className="labelspan me-2">Plan Image</span>
                                </div>

                                <div className="addplan_mdl_img_inp_dtls">
                                  <span>Select File*</span>

                                </div>

                                <button className="admin_mdl_red_btn admn_img_upld_btn">
                                  Upload
                                  <input
                                    className="addplan_mdl_img_inp addpln_hidden_dtl"
                                    type="file"
                                    name="file"
                                    accept="image/*"
                                    onChange={selectFileChange}
                                  />
                                </button>

                              </div>
                            </div>
                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex">
                                <div className="me-2">
                                  {" "}
                                  <img
                                    src={
                                      preview_file
                                        ? preview_file
                                        : filepath
                                          ? config.Back_Url + "/" + filepath
                                          : dummy
                                    }
                                    style={{ width: 117 }}
                                  />
                                </div>
                                <p style={{ fontWeight: "500" }}>
                                  Image Dimension <br /> (150 X 150)
                                </p>
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className=" ">
                                {[...Array(InputCount)].map((val, index) => {
                                  return (
                                    <div className="d-sm-flex align-items-center mb-2">
                                      <p className="shrink-0 mb-0 f-12 fw-600 me-2 mt-sm-0 mt-2">
                                        Units
                                      </p>
                                      <input
                                        type="text"
                                        id={"units" + index}
                                        className="edit_inputs_align me-2 mb-2 mb-sm-0"
                                        placeholder="Enter units*"
                                        value={AddTire["units" + index]}
                                        name="wallet address"
                                        onChange={(e) => pushAndPopdata(e, index)}
                                      />
                                      { }
                                      <p className="shrink-0 mb-0 f-12 fw-600 me-2">
                                        Price per Unit
                                      </p>
                                      <input
                                        type="text"
                                        id={"Price" + index}
                                        className="edit_inputs_align me-2 mb-2 mb-sm-0"
                                        placeholder="Enter Price*"
                                        name="wallet address"
                                        value={AddTire["Price" + index]}
                                        onChange={(e) => pushAndPopdata(e, index)}
                                      />

                                      <button
                                        className="admin_mdl_red_btn"
                                        onClick={() => {
                                          pushAndPopAdd(index);
                                        }}
                                      >
                                        Add Tier
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>

                            <div
                              className="mt-3"
                              item
                              xxl={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <div className="d-sm-flex ">
                                <div>
                                  {" "}
                                  <span className="labelspan mb-sm-0 mb-2 me-2">
                                    SetUp fee
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  id="Price"
                                  value={formValue.Price}
                                  className="edit_inputs_align me-2"
                                  placeholder="Wallet Address*"
                                  name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />

                              </div>
                              {
                                validateError.Price && <span className="text-danger mtm-1">{validateError.Price}</span>
                              }
                            </div>
                          </div>
                          <div className="table_div_head">
                            <div class="container-fluid edit_table_container_align">
                              <div
                                class="table-responsive"
                                style={{ position: "relative", zIndex: 0 }}
                              >
                                <table class="table edit_user_table_align">
                                  <thead className="tiffany_thead">
                                    <tr>
                                      <th scope="col">LazyMint ERC721 & ERC 1155</th>
                                      <th scope="col">Bulk LazyMint SoulBound Tokens</th>
                                      <th scope="col">Bulk Minting</th>
                                      <th scope="col">Token Scanner</th>
                                      <th scope="col">DashBoard And Profile</th>
                                      <th scope="col">Campaign Page</th>
                                    </tr>
                                  </thead>
                                 
                                  <tbody>
                                    <tr>

                                      {
                                        formValue.ERC == 'true' ?
                                          <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" checked="checked" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                          :
                                          <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                      }

                                      {
                                        formValue.Soulbound == 'true' ?
                                          <td><input type="checkbox" className='table_check_align' id="Soulbound" name="Soulbound" checked="checked" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                          :
                                          <td><input type="checkbox" className='table_check_align' id="Soulbound" name="Soulbound" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                      }


                                      {
                                        formValue.Bulkminting == 'true' ?
                                          <td><input type="checkbox" className='table_check_align' id="Bulkminting" name="Bulkminting" checked="checked" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                          :
                                          <td><input type="checkbox" className='table_check_align' id="Bulkminting" name="Bulkminting" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                      }



                                      {
                                        formValue.TokenScanner == 'true' ?
                                          <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" checked="checked" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                          :
                                          <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                      }


                                      {
                                        formValue.DashBoardAndProfile == 'true' ?
                                          <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" checked="checked" name="DashBoardAndProfile" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                          :
                                          <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" name="DashBoardAndProfile" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                      }

                                      {
                                        formValue.DomainCampaign == 'true' ?
                                          <td><input type="checkbox" className='table_check_align' id="DomainCampaign" checked="checked" name="DomainCampaign" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                          :
                                          <td><input type="checkbox" className='table_check_align' id="DomainCampaign" name="DomainCampaign" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                      }


                                    </tr >
                                  </tbody >
                                </table >
                              </div >
                            </div >
                          </div >
                          <div className="text-right">
                            {" "}
                            <button
                              className="admin_mdl_red_btn mt-4"
                              onClick={() => {
                                UpdatePlan();
                              }}
                            >
                              Confirm
                            </button>
                          </div>
                        </div >
                      </div >
                    </div >
                  </div >
                </div >

                {/* views plan */}
                <div
                  class="modal fade newthememodal"
                  id="PlansViewShow"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog  modal-dialog-scrollable modal-lg">
                    <div class="modal-content">
                      <div class="modal-header plan_view_show_modal">
                        <h5
                          class="modal-title plan_view_title_align"
                          id="staticBackdropLabel"
                        >
                          Plans
                        </h5>
                        <button
                          type="button"
                          class="close modal_cls_btn_align"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body plan_view_modal_body_align">
                        <div className="">
                          <div className="w-100 themetable">
                            <ReactDatatable
                              responsive={responsive}
                              className="table table-striped table-responsive react_table_border_align themetable"
                              config={configdata12}
                              records={PlanShowTable}
                              columns={columnsPlansTable}
                              onPageChange={pageChange()}
                            />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* delete plan Model*/}
                <div
                  class="modal fade newthememodal"
                  id="deleteplan"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabindex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog  modal-dialog-scrollable modal-sm">
                    <div class="modal-content">
                     
                      <div class="modal-body edituser_modal_body_align">
                        <p className="text-danger fw-600">DELETE ITEM</p>
                        <div container className="mt-1" spacing={1}>
                          <div item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Select
                              onChange={(e) => onplandel(e)}
                              options={Plans}
                              label="Single select"
                              isSearchable={false}
                              styles={customStyles}
                              classNamePrefix="react-select update_plan_top_slct"
                              formControlProps={{
                                fullWidth: true,
                              }}
                            />
                          </div>
                        </div>
                        <p>Are you sure you would like to delete this plan?</p>
                        <div className="d-flex jc-between flex1 gap-10">
                          <button
                            className="btn btn-danger"
                            onClick={(e) => plandelete(e)}
                          >
                            Delete
                          </button>

                          <button
                            className="btn btn-secondary"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Row>
            </div>
            <div>

            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Subscriptionadd